import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { useT } from "@/i18n";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bot, Sparkles, ListTodo, MessageCircle, Workflow } from "lucide-react";

export default function Upsell({ status }) {
  const t = useT();
  const [loading, setLoading] = useState(false);
  const trial = !status?.trial_used;
  const price = status?.price_eur ?? 20;

  const subscribe = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/coach/assistant/subscribe", { origin_url: window.location.origin });
      if (data?.checkout_url) { window.location.href = data.checkout_url; return; }
      setLoading(false);
    } catch (err) { toast.error(apiError(err, t("aipa.checkout_error"))); setLoading(false); }
  };

  const features = [
    { icon: Sparkles, title: t("aipa.feature_briefing"), desc: t("aipa.feature_briefing_desc") },
    { icon: ListTodo, title: t("aipa.feature_tasks"), desc: t("aipa.feature_tasks_desc") },
    { icon: MessageCircle, title: t("aipa.feature_chat"), desc: t("aipa.feature_chat_desc") },
    { icon: Workflow, title: t("aipa.feature_workflows"), desc: t("aipa.feature_workflows_desc") },
  ];

  return (
    <div data-testid="aipa-upsell">
      <Seo title={t("aipa.seo")} noindex />
      <div className="overflow-hidden rounded-3xl border border-border bg-gradient-to-br from-primary/10 via-card to-card p-8">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary/15 px-3 py-1 text-xs font-semibold text-primary"><Bot className="h-4 w-4" /> {t("aipa.title")}</div>
        <h1 className="max-w-2xl font-display text-3xl text-foreground sm:text-4xl">{t("aipa.upsell_headline")}</h1>
        <p className="mt-3 max-w-xl text-sm text-muted-foreground">{t("aipa.upsell_sub")}</p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <Button size="lg" className="rounded-full" disabled={loading} onClick={subscribe} data-testid="aipa-subscribe">
            {loading ? t("aipa.starting") : (trial ? t("aipa.start_trial") : t("aipa.start_sub"))}
          </Button>
          <span className="text-sm font-semibold text-foreground">{t("aipa.price_line", { price })}</span>
        </div>
        <p className="mt-2 text-xs text-muted-foreground">{trial ? `${t("aipa.trial_note")} · ` : ""}{t("aipa.consent_hint")}</p>
      </div>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {features.map((f) => (
          <div key={f.title} className="rounded-2xl border border-border bg-card p-5">
            <f.icon className="h-5 w-5 text-primary" />
            <p className="mt-2 text-sm font-semibold text-foreground">{f.title}</p>
            <p className="mt-1 text-sm text-muted-foreground">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
